import { CREATIVE_MEDIATYPES_TYPES } from "../Tabs/CreativeListUtils";
import { EditCreativeMediatypeConfig } from "./EditCreativeConfigUtils";
import { TVAD_CONFIG } from "./Configs/TVADEditCreativeConfig";
import * as R from "ramda";

export const mediatypeConfigs: Record<string, EditCreativeMediatypeConfig> = {
  [CREATIVE_MEDIATYPES_TYPES.LINEAR_STREAMING]: TVAD_CONFIG,
};

export const getMediatypeConfig = (mediatype: string): EditCreativeMediatypeConfig => {
  const mediatypeConfig: EditCreativeMediatypeConfig = {
    getCreativeChanges: () => {},
    getCreativeID: () => {},
    getCustomAttributes: () => {},
    getSections: () => {},
    renderModalHeader: () => {},
    updateCreative: () => {},
    ...R.defaultTo({}, mediatypeConfigs[mediatype]),
  };
  return mediatypeConfig;
};
